import { render } from "./BlockCategory.vue?vue&type=template&id=bd20d47c&ts=true"
import script from "./BlockCategory.vue?vue&type=script&lang=ts"
export * from "./BlockCategory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__